import { SingleRowAction, MultiRowAction, SelectAllAction, CRMSelectAllOptions } from '@galaxy/crm/static';
import { Row } from '@vendasta/galaxy/table';
import { ContactProvider } from '@galaxy/email-ui/shared';
import { EmailWorkflowService } from './email-workflow.service';
import { EmailProvider } from './send-email/constants';

export function EmailSingleRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  provider: EmailProvider,
  contactProvider?: ContactProvider,
): SingleRowAction {
  return {
    label: label,
    callback: (row) => {
      service.openEmailComposerFromRows(namespace, userId, [row], provider, [], contactProvider);
    },
  };
}

export function EmailMultiRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  provider: EmailProvider,
  contactProvider?: ContactProvider,
): MultiRowAction {
  return {
    label: label,
    callback: (rows) => {
      service.openEmailComposerFromRows(namespace, userId, rows, provider, [], contactProvider);
    },
  };
}

export function EmailSelectAllRowAction(
  namespace: string,
  userId: string,
  service: EmailWorkflowService,
  label: string,
  provider: EmailProvider,
  contactProvider?: ContactProvider,
): SelectAllAction {
  return {
    label: label,
    callback: (rows: Row[], _options?: CRMSelectAllOptions) => {
      service.openEmailComposerFromRows(namespace, userId, rows, provider, [], contactProvider);
    },
  };
}
